import React from "react";
import { useGetActivityFeedDetail } from "api/showing-activity/query";

// Assets
import IconXSrc from "assets/x-black.svg";
import DefaultImage from "assets/empty-listing-photo.png";

// Components
import CModal from "components/v1/modal";

const ModalDetailFeed = ({ onClose, feedId, ...props }) => {
  const { data, isLoading } = useGetActivityFeedDetail({
    id: feedId,
    enabled: !!feedId,
  });
  const feedDetail = data?.data?.data || {};
  const [imageAspectRatio, setImageAspectRatio] =
    React.useState("aspect-[327/184]");

  const handleImageLoad = (e) => {
    const img = e.target;
    const width = img.naturalWidth;
    const height = img.naturalHeight;

    if (width === height) {
      setImageAspectRatio("aspect-square");
    } else if (height > width) {
      setImageAspectRatio("aspect-[184/327]");
    } else {
      setImageAspectRatio("aspect-[327/184]");
    }
  };

  return (
    <CModal onClose={onClose} {...props}>
      <div className="w-[458px] rounded-md h-full">
        <div className="py-2 px-6 flex items-center justify-between border-b border-solid border-[#D8D8D9]">
          <span className="text-[17px] font-inter-semibold text-[#252526]">
            Detail Showing: {feedDetail?.client?.full_name || "Loading..."}
          </span>
          <img
            src={IconXSrc}
            alt="Close"
            onClick={onClose}
            className="cursor-pointer w-[14px] h-[14px] object-contain"
          />
        </div>
        {isLoading ? (
          <div className="py-8 px-4 text-center">
            <p className="text-[13px] font-inter text-[#808285]">Loading...</p>
          </div>
        ) : (
          <div className="h-[690px] overflow-y-auto">
            <div className="py-2 px-4 border-b-[0.5px] border-dashed border-[#DEDFDE] flex flex-col gap-1">
              {feedDetail?.is_cobroke && (
                <span className="inline-flex items-center justify-center w-fit h-4 px-1 bg-[#EBF0F7] rounded-[2px] text-[11px] font-inter-semibold text-[#3268AE] mt-1">
                  Co Broking
                </span>
              )}
              <p className="text-[17px] font-inter-semibold text-[#686A68] leading-[27.5px]">
                Informasi kunjungan
              </p>
              <p className="text-[11px] font-inter text-[#686A68]">
                Tanggal Kunjungan
              </p>
              <p className="text-[13px] font-inter text-[#252526]">
                {feedDetail?.visit_date || "-"}
              </p>
              {feedDetail?.is_marketing_buyer && (
                <>
                  <p className="text-[11px] font-inter text-[#686A68]">
                    Alamat Property
                  </p>
                  <p className="text-[13px] font-inter text-[#252526]">
                    {feedDetail?.property?.street || "-"}
                  </p>
                </>
              )}
            </div>
            {!feedDetail?.is_marketing_buyer && (
              <div className="flex items-center gap-[12px] py-2 px-4 border-b-[0.5px] border-dashed border-[#DEDFDE]">
                <img
                  src={feedDetail?.property?.image ?? DefaultImage}
                  alt={feedDetail?.property?.title}
                  className="rounded-[4px] w-[63px] h-[63px] object-cover"
                />

                <div>
                  <p className="line-clamp-2 text-[13px] font-inter text-[#252526]">
                    {feedDetail?.property?.title || "-"}
                  </p>
                  <p className="text-[13px] font-inter text-[#686A68]">
                    {feedDetail?.property?.area || ""}
                    {feedDetail?.property?.area && feedDetail?.property?.city
                      ? ", "
                      : ""}
                    {feedDetail?.property?.city || ""}
                  </p>
                </div>
              </div>
            )}
            <div className="py-2 px-4 border-b-[0.5px] border-dashed border-[#DEDFDE] flex flex-col gap-0.5">
              <p className="text-[17px] font-inter-semibold text-[#686A68] leading-[27.5px] mb-1">
                Prospek Pembeli/Penyewa
              </p>
              <p className="text-[11px] font-inter text-[#686A68]">Nama:</p>
              <p className="text-[13px] font-inter text-[#252526] mb-1">
                {feedDetail?.client?.full_name || "-"}
              </p>
              <p className="text-[11px] font-inter text-[#686A68]">
                Tanggapan:
              </p>
              <p className="text-[13px] font-inter text-[#252526]">
                {feedDetail?.client?.response || "-"}
              </p>
            </div>
            <div className="py-2 px-4 mb-2">
              <p className="text-[17px] font-inter-semibold text-[#686A68] leading-[27.5px] mb-2">
                Hasil Kunjungan
              </p>
              {!!feedDetail?.visit_image && (
                <img
                  src={feedDetail?.visit_image}
                  alt="Hasil Kunjungan"
                  className={`rounded-[4px] w-full ${imageAspectRatio} object-cover`}
                  onLoad={handleImageLoad}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </CModal>
  );
};

export default function Wrapper({
  isOpen,
  feedId,
  onAfterOpen,
  onRequestClose,
  ...props
}) {
  if (!isOpen) return null;
  return (
    <ModalDetailFeed
      isOpen={isOpen}
      feedId={feedId}
      onAfterOpen={onAfterOpen}
      onRequestClose={onRequestClose}
      {...props}
    />
  );
}
